import { socketService } from '@aqx-core/common/socket';

import { IMetaTraderMessage } from '../topics/metatrader';

class MetaTraderTopicSubscription {
  public subscribe = (metaTraderTopicReceiver: (payload: IMetaTraderMessage | undefined) => void) => {
    socketService.topics().metatrader.subscribe({
      receiver: (payload) => metaTraderTopicReceiver(payload)
    });
  };

  public unsubscribe = (metaTraderTopicReceiver: (payload: IMetaTraderMessage | undefined) => void) => {
    socketService.topics().metatrader.unsubscribe({
      receiver: (payload) => metaTraderTopicReceiver(payload)
    });
  };
}

export const metaTraderTopicSubscription = new MetaTraderTopicSubscription();
